import * as React from 'react';
import 'font-awesome/css/font-awesome.min.css';
import "primereact/resources/themes/fluent-light/theme.css";
import "primeflex/primeflex.css"
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import './../public/assets/css/App.css'
import { ProgramContainer } from './entities/formTemplateDataType';
import { User } from './entities/User';
import { WelcomeComponent } from './commonComponent/WelcomeComponent';
import { HeaderComponent } from './commonComponent/HeaderComponent';
import { FooterComponent } from './commonComponent/FooterComponent';
import { ListFormComponent } from './designComponent/ListFormComponent';
import { DetailFormComponent } from './designComponent/DetailFormComponent';
import './../public/assets/css/ontario-design-system/styles/ds-theme.min.css'
import 'regenerator-runtime/runtime'
import LocalStorageService from './services/SessionStorageService';
import msalInstance from "./security/msalInstance";
import { MsalProvider } from '@azure/msal-react';
import { parse } from 'flatted';
import * as CircularJSON from 'circular-json';
interface Props {

}

interface State {
    user: User,
    isAuthenticated: boolean,
    hideWelcome: boolean;
    hideDetail: boolean;
    hideList: boolean;
    programContainer: ProgramContainer;
    graphData,
}

export class ContainerForm extends React.Component<Props, State> {
    hash: string;
    timer;

    constructor(props: Props) {
        super(props);

        this.state = {
            user: null,
            hideWelcome: false,
            hideList: true,
            hideDetail: true,
            programContainer: null,
            isAuthenticated: false,
            graphData: null,
        };

        this.timer = null; 
    }

    render() {
        return (
            <MsalProvider instance={msalInstance}>
            <div style={{ height: '83px', maxWidth: '100%', marginBottom: '30px' }} >
                <div style={{ marginBottom: '30px' }} >
                    <HeaderComponent  callback={() => { this.setState({ hideWelcome: true, hideDetail: true,  hideList: false})}}
                    userLoadedCallBack={()=>{
                       
                    }}  />
                </div>
                <div>
                    <WelcomeComponent state={this.state}
                        callback={(p) => { let user = this.state.user; this.setState({ hideWelcome: true, hideDetail: true, hideList: false, user: user }, () => window.scrollTo(0, 0)); }} />
                </div>

                <div style={{ maxWidth: '80%', margin: '0 auto', display: this.state.hideList ? 'none' : 'block' }} >
                {this.state.hideList==false? <ListFormComponent key='list_component' callback={(p) => {
                            if (p != null) {
                                 let container  = CircularJSON.parse(p.attachment) as ProgramContainer;
                                 container.id = p.id;
                                container.createdById = p.createdById;
                                container.Creator=p.userName;
                                this.setState({ hideWelcome: true, hideDetail: false, hideList: true, programContainer: container }, () => window.scrollTo(0, 0))
                            } else {
                                let newProgramContaier = new ProgramContainer();
                                newProgramContaier.ListOfFormSections = [];
                                newProgramContaier.createdById = LocalStorageService.getUserId();
                                this.setState({ programContainer: newProgramContaier });
                            }
                            this.setState({ hideWelcome: true, hideDetail: false, hideList: true }, () => window.scrollTo(0, 0))
                    }} />: null}
                </div>

                <div style={{ maxWidth: '80%', margin: '0 auto', display: this.state.hideDetail ? 'none' : 'block' }} >
                    <DetailFormComponent isEng={true}
                        callback={p => {this.setState({ programContainer: p }) }}
                        callbackOriginalData={(p) => console.log(p)}
                        hash={this.hash}
                        key={"DetailFormComponent"}
                        programContainer={this.state.programContainer} />
                </div>

                <FooterComponent state={this.state} />

            </div>
            </MsalProvider>
        )

    }
}
